import { TOGGLE_SELECTED, OPEN_REWARDS_GRID, CLOSE_REWARDS_GRID, UNSELECT_ALL, SHOW_ROULETTE, CLOSE_ROULETTE } from '../constants/actionTypes';

export function toggleSelected(id) {
  return {
    type: TOGGLE_SELECTED,
    id
  };
}

export function openRewardsGrid() {
  return {
    type: OPEN_REWARDS_GRID,
  };
}

export function resetRewardsGrid() {
  return {
    type: UNSELECT_ALL,
  };
}

export function closeRewardsGrid() {
  return {
    type: CLOSE_REWARDS_GRID,
  };
}

export function showRoulette() {
  return {
    type: SHOW_ROULETTE,
  };
}

export function closeRoulette() {
  return {
    type: CLOSE_ROULETTE,
  };
}



/** WEBPACK FOOTER **
 ** ./src/actions/actions.js
 **/